import { biocharApplicationURL } from "../../../../config/api-config";
import store from "../../../../store";
import axios_base_config_site from "../../../../config/api-config";
import { initLightbox, showLightbox, convertGoogleDriveUrl } from "../../../../utils/mapUtils";
import { addBiocharStyles, addLightboxStyles } from "../../../../utils/mapUtilsStyles";

function convertUTCToNigerianTime(utcDateString) {
  if (!utcDateString) return "N/A";
  const utcDate = new Date(utcDateString);
  // Add 1 hour for Nigerian time (UTC+1)
  const nigerianDate = new Date(utcDate.getTime() + 1 * 60 * 60 * 1000);

  return nigerianDate.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function updateButtonStates(showButton, clearButton, mapView) {
  const rmSourceLayer = mapView.map.findLayerById("rmSourceLayer");
  if (rmSourceLayer) {
    const isVisible = rmSourceLayer.visible;
    const hasFilter = rmSourceLayer.definitionExpression && 
                     rmSourceLayer.definitionExpression !== "1=0" && 
                     rmSourceLayer.definitionExpression !== "";
    
    showButton.textContent = "Show P1 Purchases";
    showButton.style.backgroundColor = "#4CAF50";
    
    clearButton.style.display = isVisible && hasFilter ? 
      "inline-block" : "none";

      showButton.style.display = isVisible && hasFilter ? 
      "none" : "flex";
  }
}

// Create tabbed interface
const createTabsInterface = (feature) => {
  const mapView = store.getters["arcgisMap/getMapView"];
  const tabContainer = document.createElement("div");
  let cachedAllocations = null; // Cache for allocations data

  // Create tab buttons
  const tabButtons = document.createElement("div");
  tabButtons.className = "biochar-tabs";

  // Images tab
  const imagesTab = document.createElement("button");
  imagesTab.className = "biochar-tab active";
  imagesTab.textContent = "Images";
  imagesTab.onclick = () => switchTab(tabContainer, "images");

  // Details tab
  const detailsTab = document.createElement("button");
  detailsTab.className = "biochar-tab";
  detailsTab.textContent = "Farm Details";
  detailsTab.onclick = () => switchTab(tabContainer, "details");

  // Application tab
  const applicationTab = document.createElement("button");
  applicationTab.className = "biochar-tab";
  applicationTab.textContent = "Application Details";
  applicationTab.onclick = () => switchTab(tabContainer, "application");

  // NetCO2 tab
  const netco2Tab = document.createElement("button");
  netco2Tab.className = "biochar-tab";
  netco2Tab.textContent = "CO₂ Removal";
  netco2Tab.onclick = () => switchTab(tabContainer, "netco2");

  // P1 Purchases tab
  const purchasesTab = document.createElement("button");
  purchasesTab.className = "biochar-tab";
  purchasesTab.textContent = "P1 Purchases";
  purchasesTab.onclick = async () => {
    switchTab(tabContainer, "purchases");
    if (!purchasesContent.dataset.loaded) {
      purchasesContent.innerHTML = "";
      const loader = document.createElement("div");
      loader.className = "biochar-loader";
      purchasesContent.appendChild(loader);
      try {
        if (!cachedAllocations) {
          const biocharId = feature.graphic.attributes.id;
          if (!biocharId) throw new Error("Biochar application ID not found");
          const response = await axios_base_config_site.get(
            `${biocharApplicationURL}/${biocharId}/allocated-purchases`
          );
          cachedAllocations = response.data;
          if (!cachedAllocations.length)
            throw new Error("No P1 purchases available");
        }
        populatePurchasesTab(purchasesContent, cachedAllocations);
        purchasesContent.dataset.loaded = "true";
      } catch (error) {
        console.error("Error fetching P1 purchases:", error);
        const errorMsg = document.createElement("div");
        errorMsg.className = "biochar-error";
        errorMsg.innerHTML = `Error: ${error.message} <span class="biochar-error-close">×</span>`;
        errorMsg.querySelector(".biochar-error-close").onclick = () =>
          errorMsg.remove();
        purchasesContent.innerHTML = "";
        purchasesContent.appendChild(errorMsg);
      } finally {
        loader.remove();
      }
    }
  };

  tabButtons.appendChild(imagesTab);
  tabButtons.appendChild(detailsTab);
  tabButtons.appendChild(applicationTab);
  tabButtons.appendChild(netco2Tab);
  tabButtons.appendChild(purchasesTab);

  tabContainer.appendChild(tabButtons);

  // Create tab content
  const createTabContent = (id) => {
    const content = document.createElement("div");
    content.id = `biochar-tab-${id}`;
    content.className = "biochar-tab-content";
    tabContainer.appendChild(content);
    return content;
  };

  // Create all tab content containers
  const imagesContent = createTabContent("images");
  imagesContent.style.display = "block";
  const detailsContent = createTabContent("details");
  const applicationContent = createTabContent("application");
  const netco2Content = createTabContent("netco2");
  const purchasesContent = createTabContent("purchases");

  // Populate existing tabs
  populateImagesTab(imagesContent, feature);
  populateDetailsTab(detailsContent, feature);
  populateApplicationTab(applicationContent, feature);
  populateNetCO2Tab(netco2Content, feature);

  const showButton = document.createElement("button");
  showButton.textContent = "Show P1 Purchases";
  showButton.style.marginTop = "10px";
  showButton.style.padding = "8px 12px";
  showButton.style.backgroundColor = "#4caf50";
  showButton.style.color = "white";
  showButton.style.border = "none";
  showButton.style.borderRadius = "4px";
  showButton.style.cursor = "pointer";
  showButton.style.display = "flex";
  showButton.style.alignItems = "center";
  showButton.style.justifyContent = "center";

  const clearButton = document.createElement("button");
  clearButton.textContent = "Clear P1 Purchases";
  clearButton.style.marginTop = "10px";
  clearButton.style.marginLeft = "10px";
  clearButton.style.padding = "8px 12px";
  clearButton.style.backgroundColor = "#ff4444";
  clearButton.style.color = "white";
  clearButton.style.border = "none";
  clearButton.style.borderRadius = "4px";
  clearButton.style.cursor = "pointer";
  clearButton.style.display = "none";

  showButton.onclick = async () => {
    showButton.textContent = "";
    const loader = document.createElement("div");
    loader.className = "biochar-loader";
    showButton.appendChild(loader);
    showButton.disabled = true;

    try {
      if (!cachedAllocations) {
        const biocharId = feature.graphic.attributes.id;
        if (!biocharId) throw new Error("Biochar application ID not found");
        const response = await axios_base_config_site.get(
          `${biocharApplicationURL}/${biocharId}/allocated-purchases`
        );
        cachedAllocations = response.data;
        if (!cachedAllocations.length)
          throw new Error("No P1 purchases allocated for this application");
      }

      const rmSourceLayer = mapView.map.findLayerById("rmSourceLayer");
      if (!rmSourceLayer)
        throw new Error("Raw Material Source Layer not found");

      rmSourceLayer.visible = true;

      const layerView = await mapView.whenLayerView(rmSourceLayer);
      
      layerView.filter = null;
      rmSourceLayer.definitionExpression = null;

      const objectIds = cachedAllocations.map((p) => p.objectId);
      if (objectIds.length > 0) {
        rmSourceLayer.definitionExpression = `OBJECTID IN (${objectIds.join(",")})`;
        
        // Zoom to the filtered features
        const query = rmSourceLayer.createQuery();
        query.where = rmSourceLayer.definitionExpression;
        query.returnGeometry = true;
        const result = await rmSourceLayer.queryFeatures(query);
        if (result.features.length > 0) {
          mapView.goTo(result.features);
        }
      } else {
        rmSourceLayer.definitionExpression = "1=0";
      }

      // Update button states after successful operation
      updateButtonStates(showButton, clearButton, mapView);
    } catch (error) {
      console.error("Error showing P1 purchases:", error);
      const errorMsg = document.createElement("div");
      errorMsg.className = "biochar-error";
      errorMsg.innerHTML = `Error: ${error.message} <span class="biochar-error-close">×</span>`;
      errorMsg.querySelector(".biochar-error-close").onclick = () =>
        errorMsg.remove();
      tabContainer.appendChild(errorMsg);
    } finally {
      showButton.removeChild(loader);
      showButton.disabled = false;
    }
  };

  clearButton.onclick = () => {
    const rmSourceLayer = mapView.map.findLayerById("rmSourceLayer");
    if (rmSourceLayer) {
      rmSourceLayer.visible = false;
      rmSourceLayer.definitionExpression = "";
      mapView.whenLayerView(rmSourceLayer).then((layerView) => {
        layerView.filter = null;
      });
      
      // Update button states
      updateButtonStates(showButton, clearButton, mapView);
    }
    // Clear summary and cache
    cachedAllocations = null;
    purchasesContent.dataset.loaded = "";
    purchasesContent.innerHTML = "";
  };

  tabContainer.appendChild(showButton);
  tabContainer.appendChild(clearButton);

  updateButtonStates(showButton, clearButton, mapView);

  const rmSourceLayer = mapView.map.findLayerById("rmSourceLayer");
  if (rmSourceLayer) {
    rmSourceLayer.watch("visible", () => {
      updateButtonStates(showButton, clearButton, mapView);
    });
    
    rmSourceLayer.watch("definitionExpression", () => {
      updateButtonStates(showButton, clearButton, mapView);
    });
  }

  return tabContainer;
};

// Switch tab function
const switchTab = (container, tabName) => {
  const tabContents = container.querySelectorAll(".biochar-tab-content");
  tabContents.forEach((tab) => {
    tab.style.display = "none";
  });

  const tabs = container.querySelectorAll(".biochar-tab");
  tabs.forEach((tab) => {
    tab.className = tab.className.replace(" active", "");
  });

  document.getElementById(`biochar-tab-${tabName}`).style.display = "block";

  const activeTab = container.querySelector(
    `.biochar-tab:nth-child(${
      tabName === "images"
        ? 1
        : tabName === "details"
        ? 2
        : tabName === "application"
        ? 3
        : tabName === "netco2"
        ? 4
        : 5
    })`
  );
  activeTab.className += " active";
};

const populateImagesTab = (container, feature) => {
  // Parse image URLs
  let imageUrls = feature.graphic.attributes.imageUrls;
  if (typeof imageUrls === "string") {
    try {
      imageUrls = JSON.parse(imageUrls);
    } catch (error) {
      imageUrls = imageUrls.split(",").map(url => url.trim()).filter(url => url);
    }
  }
  if (!Array.isArray(imageUrls)) imageUrls = [];

  // Initialize lightbox and styles
  initLightbox("lightbox");
  addLightboxStyles();

  // Create gallery container
  const gallery = document.createElement("div");
  gallery.className = "biochar-gallery";

  if (imageUrls.length === 0) {
    const noImagesMsg = document.createElement("p");
    noImagesMsg.textContent = "No images available";
    noImagesMsg.style.margin = "10px 0";
    container.appendChild(noImagesMsg);
    return;
  }

  // Convert all URLs upfront
  const convertedUrls = imageUrls.map(url => convertGoogleDriveUrl(url));

  // Create gallery items
  imageUrls.forEach((url, index) => {
    const convertedUrl = convertGoogleDriveUrl(url);
    const galleryItem = document.createElement("div");
    galleryItem.className = "biochar-gallery-item";

    // Loader container
    const loaderContainer = document.createElement("div");
    loaderContainer.className = "biochar-loader-container";
    const loader = document.createElement("div");
    loader.className = "biochar-loader";
    loaderContainer.appendChild(loader);

    // Image element
    const img = document.createElement("img");
    img.style.display = "none";
    img.alt = `Biochar Image ${index + 1}`;
    // img.loading = "lazy";

    img.onload = () => {
      loaderContainer.style.display = "none";
      img.style.display = "block";
    };

    img.onerror = () => {
      console.error(`Failed to load image: ${convertedUrl}`);

      if (convertedUrl.includes("drive.google.com/thumbnail")) {
        const fileId = new URL(convertedUrl).searchParams.get("id");
        if (fileId) {
          const fallbackUrl = `https://drive.google.com/uc?export=view&id=${fileId}`;
          img.src = fallbackUrl;

          img.onerror = () => {
            console.error(
              `Both image loading methods failed for ID: ${fileId}`
            );
            loaderContainer.innerHTML = "";
            const errorMsg = document.createElement("p");
            errorMsg.textContent = `Image ${index + 1} failed to load`;
            errorMsg.style.color = "red";
            errorMsg.style.fontSize = "12px";
            errorMsg.style.textAlign = "center";
            loaderContainer.appendChild(errorMsg);
          };
          return;
        }
      }

      loaderContainer.innerHTML = "";
      const errorMsg = document.createElement("p");
      errorMsg.textContent = `Image ${index + 1} failed to load`;
      errorMsg.style.color = "red";
      errorMsg.style.fontSize = "12px";
      errorMsg.style.textAlign = "center";
      loaderContainer.appendChild(errorMsg);
    };

    img.src = convertedUrl;
    img.onclick = () => showLightbox(convertedUrls, index, "lightbox");

    galleryItem.appendChild(loaderContainer);
    galleryItem.appendChild(img);
    gallery.appendChild(galleryItem);
  });

  container.appendChild(gallery);
};

// Populate details tab with field information
const populateDetailsTab = (container, feature) => {
  const table = document.createElement("table");
  table.className = "biochar-fields-table";

  const fieldInfos = [
    { fieldName: "ownerName", label: "Owner Name" },
    { fieldName: "eventId", label: "Event ID" },
    { fieldName: "farmSize", label: "Farm Size (ha)" },
    { fieldName: "startDate", label: "Start Date" },
    { fieldName: "endDate", label: "End Date" },
    { fieldName: "community", label: "Community" },
    { fieldName: "lga", label: "LGA" },
    { fieldName: "officerName", label: "Officer Name" },
    { fieldName: "contactInfo", label: "Contact Info" },
  ];

  fieldInfos.forEach((field) => {
    const value = feature.graphic.attributes[field.fieldName];
    if (value !== undefined && value !== null) {
      const row = document.createElement("tr");

      const labelCell = document.createElement("td");
      labelCell.className = "biochar-field-label";
      labelCell.textContent = field.label;

      const valueCell = document.createElement("td");
      valueCell.textContent = value;

      row.appendChild(labelCell);
      row.appendChild(valueCell);
      table.appendChild(row);
    }
  });

  container.appendChild(table);
};

// Populate Application tab
const populateApplicationTab = (container, feature) => {
  const table = document.createElement("table");
  table.className = "biochar-fields-table";

  const fieldInfos = [
    { fieldName: "batchIds", label: "Batch ID" },
    { fieldName: "crop", label: "Crop" },
    { fieldName: "amountPerSpot", label: "Amount per Spot (kg)" },
    { fieldName: "numberOfSpots", label: "Number of Spots" },
    { fieldName: "amountOfBiochar", label: "Amount of Biochar (kg)" },
    { fieldName: "transportVehicleType", label: "Transport Vehicle Type" },
    { fieldName: "distanceToFactory", label: "Distance To Factory (km)",
      formatter: (value) => value !== null && value !== undefined ? Number(value).toFixed(2) : "N/A"}
  ];

  fieldInfos.forEach((field) => {
    const value = feature.graphic.attributes[field.fieldName];
    if (value !== undefined && value !== null) {
      const row = document.createElement("tr");

      const labelCell = document.createElement("td");
      labelCell.className = "biochar-field-label";
      labelCell.textContent = field.label;

      const valueCell = document.createElement("td");
      valueCell.textContent = field?.formatter ? field.formatter(value) : value;

      row.appendChild(labelCell);
      row.appendChild(valueCell);
      table.appendChild(row);
    }
  });

  container.appendChild(table);
};

// New NetCO2 tab
const populateNetCO2Tab = (container, feature) => {
  const netCo2Value = feature.graphic.attributes.netCo2;
  
  const contentDiv = document.createElement("div");
  contentDiv.style.padding = "15px";
  contentDiv.style.textAlign = "center";

  const title = document.createElement("h3");
  title.textContent = "CO₂ Removal Analysis";
  title.style.marginTop = "0";
  title.style.marginBottom = "20px";
  title.style.color = "#333";
  contentDiv.appendChild(title);

  const co2Display = document.createElement("div");
  co2Display.style.padding = "20px";
  co2Display.style.border = "2px solid #ddd";
  co2Display.style.borderRadius = "8px";
  co2Display.style.marginBottom = "20px";
  co2Display.style.backgroundColor = "#f9f9f9";

  const co2Label = document.createElement("div");
  co2Label.textContent = "Net CO₂ Removal";
  co2Label.style.fontSize = "16px";
  co2Label.style.fontWeight = "bold";
  co2Label.style.marginBottom = "10px";
  co2Label.style.color = "#666";

  const co2Value = document.createElement("div");
  if (netCo2Value !== null && netCo2Value !== undefined) {
    const numValue = Number(netCo2Value);
    const sign = numValue >= 0 ? '+' : '';
    co2Value.textContent = `${sign}${numValue.toFixed(3)} tCO₂e`;
    co2Value.style.fontSize = "24px";
    co2Value.style.fontWeight = "bold";
    
    // Color coding
    if (numValue > 0) {
      co2Value.style.color = "#4CAF50"; // Green for positive (carbon removal)
      co2Display.style.borderColor = "#4CAF50";
      co2Display.style.backgroundColor = "#f1f8e9";
    } else if (numValue < 0) {
      co2Value.style.color = "#f44336"; // Red for negative (net emissions)
      co2Display.style.borderColor = "#f44336";
      co2Display.style.backgroundColor = "#ffebee";
    } else {
      co2Value.style.color = "#ff9800"; // Orange for neutral
      co2Display.style.borderColor = "#ff9800";
      co2Display.style.backgroundColor = "#fff3e0";
    }
  } else {
    co2Value.textContent = "N/A";
    co2Value.style.fontSize = "18px";
    co2Value.style.color = "#999";
  }

  co2Display.appendChild(co2Label);
  co2Display.appendChild(co2Value);
  contentDiv.appendChild(co2Display);

  // Explanation text
  const explanation = document.createElement("div");
  explanation.style.fontSize = "14px";
  explanation.style.color = "#666";
  explanation.style.lineHeight = "1.5";
  explanation.style.textAlign = "left";
  
  // const explanationTitle = document.createElement("div");
  // explanationTitle.textContent = "What this means:";
  // explanationTitle.style.fontWeight = "bold";
  // explanationTitle.style.marginBottom = "8px";
  
  // const explanationText = document.createElement("div");
  // explanationText.innerHTML = `
  //   <p style="margin: 5px 0;"><strong>Positive values (+):</strong> Net carbon removal from atmosphere</p>
  //   <p style="margin: 5px 0;"><strong>Negative values (-):</strong> Net carbon emissions to atmosphere</p>
  //   <p style="margin: 5px 0;"><strong>Note:</strong> Excludes emission from factory to store</p>
  // `;
  
  // explanation.appendChild(explanationTitle);
  // explanation.appendChild(explanationText);
  contentDiv.appendChild(explanation);

  container.appendChild(contentDiv);
};

// Parse pricePerTon for consistent display
const parsePricePerTon = (price) => {
  try {
    const cleaned = price.replace(/[^0-9.km]/g, "").toLowerCase();
    if (cleaned.endsWith("k")) {
      return (parseFloat(cleaned.replace("k", "")) * 1000).toLocaleString();
    } else if (cleaned.endsWith("m")) {
      return (parseFloat(cleaned.replace("m", "")) * 1000000).toLocaleString();
    }
    return parseFloat(cleaned).toLocaleString();
  } catch (error) {
    console.warn(`Failed to parse pricePerTon: ${price}`, error);
    return price;
  }
};

// Populate P1 Purchases tab
const populatePurchasesTab = (container, allocations) => {
  const table = document.createElement("table");
  table.className = "biochar-fields-table";

  const fieldInfos = [
    { fieldName: "supplierName", label: "Supplier Name" },
    { fieldName: "community", label: "Community" },
    { fieldName: "suppliedTonnage", label: "Supplied Tonnage (tons)" },
    { fieldName: "biocharUsed", label: "Biochar Used (kg)" },
    { fieldName: "pricePerTon", label: "Price per Ton" },
    { fieldName: "date", label: "Date" },
  ];

  allocations.forEach((allocation, index) => {
    const row = document.createElement("tr");
    const labelCell = document.createElement("td");
    labelCell.className = "biochar-field-label";
    labelCell.textContent = `Purchase ${index + 1}`;
    row.appendChild(labelCell);

    const valueCell = document.createElement("td");
    const subTable = document.createElement("table");
    fieldInfos.forEach((field) => {
      const subRow = document.createElement("tr");
      const subLabelCell = document.createElement("td");
      subLabelCell.textContent = field.label;
      subLabelCell.className = "biochar-field-label";
      const subValueCell = document.createElement("td");
      let value = allocation[field.fieldName] || "N/A";
      if (field.fieldName === "pricePerTon" && value !== "N/A") {
        value = parsePricePerTon(value);
      } else if (field.fieldName === "date" && value !== "N/A") {
        value = new Date(value).toLocaleDateString();
      } else if (
        field.fieldName === "suppliedTonnage" ||
        field.fieldName === "biocharUsed"
      ) {
        value = Number(value).toFixed(2);
      }
      subValueCell.textContent = value;
      subRow.appendChild(subLabelCell);
      subRow.appendChild(subValueCell);
      subTable.appendChild(subRow);
    });
    valueCell.appendChild(subTable);
    row.appendChild(valueCell);
    table.appendChild(row);
  });

  container.appendChild(table);
};

// Biochar Applications layer
const biocharApplications = {
  url: biocharApplicationURL,
  title: "Biochar Applications",
  renderer: {
    type: "unique-value",
    valueExpression: `
      if (Find("EXPERIMENTAL", $feature.batchIds) > -1) {
        return "experimental";
      } else {
        return "normal";
      }
    `,
    defaultSymbol: {
      style: "square",
      type: "simple-marker",
      color: "#8FC54D",
      size: 15,
    },
    uniqueValueInfos: [
      {
        value: "experimental",
        symbol: {
          style: "square",
          type: "simple-marker",
          color: "#FFD700",
          size: 15,
        }
      },
      {
        value: "normal",
        symbol: {
          style: "square",
          type: "simple-marker",
          color: "#8FC54D",
          size: 15,
        }
      }
    ]
  },
  outFields: ["*"],
  fields: [
    { name: "id", type: "string" },
    { name: "ownerName", type: "string" },
    { name: "eventId", type: "string" },
    { name: "farmSize", type: "double" },
    { name: "crop", type: "string" },
    { name: "startDate", type: "string" },
    { name: "endDate", type: "string" },
    { name: "community", type: "string" },
    { name: "lga", type: "string" },
    { name: "amountPerSpot", type: "double" },
    { name: "numberOfSpots", type: "integer" },
    { name: "bikeEmissions", type: "double" },
    { name: "truckEmissions", type: "double" },
    { name: "netCo2", type: "double" },
    { name: "distanceToFactory", type: "double" },
    { name: "batchIds", type: "string" },
    { name: "amountOfBiochar", type: "double" },
    { name: "transportVehicleType", type: "string" },
    { name: "officerName", type: "string" },
    { name: "contactInfo", type: "string" },
    { name: "imageUrls", type: "string" },
  ],
  popupTemplate: {
    title:
      "Biochar Application At {ownerName} Farm -  {amountOfBiochar}Kg Applied",
    content: [
      {
        type: "custom",
        creator: function (feature) {
          addBiocharStyles();

          const attributes = feature.graphic.attributes;
          const startDateLocal = convertUTCToNigerianTime(attributes.startDate);
          const endDateLocal = convertUTCToNigerianTime(attributes.endDate);

          attributes.startDateLocal = startDateLocal;
          attributes.endDateLocal = endDateLocal;
          return createTabsInterface(feature);
        },
      },
    ],
  },
};

export {
  biocharApplications,
};